import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 59E94B6E-589B-4DB9-AAB7-397E17E2B272
 * name flash-alert
 * version: 3.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/flash-alert.svg
 * tags
 * - Weather 
 * - Alert / Error 
 */
export const FlashAlertIcon = createSvgIcon(<><path d="M5,2V13H8V22L15,10H11L15,2M17,15H19V17H17V15M17,7H19V13H17V7Z" /></>, 'FlashAlertIcon');
export default FlashAlertIcon